var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.488,
    height: 23.671,
    viewBox: "0 0 16.488 23.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#f12b5d;}.a{clip-rule:evenodd;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.e{clip-path:url(#c);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1491.167-1292a4.906,4.906,0,0,1,1.992.806,4.565,4.565,0,0,1,1.781,4.8,4.565,4.565,0,0,1-3.748,3.421,4.55,4.55,0,0,1-5.165-4.025,4.56,4.56,0,0,1,3.578-4.928c.093-.019.185-.047.277-.07Z",
    transform: "translate(-1486 1292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-878.179H791.432V-1494H0Z",
    transform: "translate(0 1494)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1480.083-1254.4a2.894,2.894,0,0,1-2.489-1.364,3.222,3.222,0,0,1-.577-1.851,23.8,23.8,0,0,1,.036-2.61,8.512,8.512,0,0,1,2.281-5.162,7.93,7.93,0,0,1,4.932-2.554,8.182,8.182,0,0,1,8.532,5.057,8.579,8.579,0,0,1,.688,3.5c-.007.593,0,1.186,0,1.778a3.271,3.271,0,0,1-2.368,3.156,1.628,1.628,0,0,1-.418.049q-2.728,0-5.456,0C1483.524-1254.4,1481.8-1254.416,1480.083-1254.4Z",
    transform: "translate(-1477 1268)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-370 -356.329)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(373.71 356.329)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-612.535 -83.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1484.44-1293h10.435v10.2H1484.44Z",
    transform: "translate(-872.548 1375.852)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(370 366.397)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-608.826 -93.156)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1475.934-1269.953h17.355v14.831h-17.355Z",
    transform: "translate(-867.548 1362.304)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidEmail);
export default __webpack_public_path__ + "static/media/validEmail.a0c4f7a16ea13f760b16edea1c2547a3.svg";
export { ForwardRef as ReactComponent };